import { spawn } from 'redux-saga/effects';

import { sagas as detailsSagas } from './detailsModule';
import stateDataSagas from './stateData/stateDataSagas';

export default function* sagas() {
	yield spawn(detailsSagas);
	yield spawn(stateDataSagas);
}
